module.exports = __webpack_public_path__ + "static/media/write_circle.81a6e621.png";